import React, { useState, useMemo, useCallback } from 'react'
import styled from 'styled-components'

import { BorderRad, Colors, Sizes, Transitions } from '@/common/constants'
import { TableListItemAsLinkHover } from '@/common/components/List'
import { Skeleton } from '@/common/components/Skeleton'
import { DropDownButton, DropDownToggle } from '@/common/components/buttons/DropDownToggle'
import { RowGapBlock } from '@/common/components/page/PageContent'
import { AccountInfo } from '@/accounts/components/AccountInfo'
import { Badge, TextMedium, TextSmall, TokenValue } from '@/common/components/typography'
import { BadgeStatus } from '@/common/components/BadgeStatus'
import { ButtonPrimary } from '@/common/components/buttons'
import { Validator } from '../types/Validator'
import { useModal } from '@/common/hooks/useModal'
import { CandidacyPreviewModalCall } from '@/council/modals/CandidacyPreview/types'

interface ValidatorItemProps {
  validator: Validator
  onClick : ()=>void
}
export const ValidatorItem = ({ validator, onClick }: ValidatorItemProps) => {
  const { member, address, verification, state, totalRewards, APR, startedOn } = validator
  const validatorAccount = useMemo(
    () => ({
      name: 'unknown',
      address: address,
      source: '',
    }),
    [validator]
  )
  const { showModal } = useModal()
  const showCandidate = useCallback(() => {
    showModal<CandidacyPreviewModalCall>({
      modal: 'CandidacyPreview',
      data: { id: "0000001o" },
    })
  }, [showModal])

  return (
    <ValidatorItemWrapper>
      <ValidatorItemWrap key={address} onClick={onClick}>
        <AccountInfo account={validatorAccount} />
        {verification ? (
          <BadgeStatus inverted size="l">
            verified
          </BadgeStatus>
        ) : (
          <div></div>
        )}
        <BadgeStatus inverted size="l">
          {state ? 'active' : 'waiting'}
        </BadgeStatus>
        <TokenValue size="xs" value={totalRewards} />
        <TextMedium bold> {APR} </TextMedium>
        <TextSmall> Dec 2022 </TextSmall>
        <ButtonPrimary size="small" onClick={() => alert(`You select validator:${address} to nominate`)}>
          Nominate
        </ButtonPrimary>
      </ValidatorItemWrap>
    </ValidatorItemWrapper>
  )
}

const ValidatorItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${Colors.Black[100]};
  border-radius: ${BorderRad.s};
  cursor: pointer;
  transition: ${Transitions.all};

  ${TableListItemAsLinkHover}
`

export const ValidatorItemWrap = styled.div`
  display: grid;
  grid-template-columns: 200px repeat(2, 80px) 120px 50px 80px 100px;
  grid-template-rows: 1fr;
  justify-content: space-between;
  justify-items: end;
  align-items: center;
  width: 100%;
  height: ${Sizes.accountHeight};
  padding: 16px 8px 16px 16px;
  margin-left: -1px;

  ${Skeleton} {
    min-width: 80%;
    height: 1.2rem;
  }
`

const AccountControls = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 32px);
  grid-template-rows: 32px;
  grid-column-gap: 4px;
`
const StyledDropDown = styled(DropDownToggle)`
  row-gap: 16px;
  padding: 16px;
  background-color: ${Colors.Black[50]};
`

const ValueAndLocks = styled(RowGapBlock)`
  position: relative;
`
